import 'react';

const ImportSuccessSvg2 = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <circle fill="#5CC58F" cx={10} cy={10} r={7} />
            <path
                stroke="#FFF"
                strokeWidth={1.25}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.268 9.84l2.41 2.394 3.59-4"
            />
        </g>
    </svg>
);

export default ImportSuccessSvg2;
